var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_c('b',[_vm._v("MDL")]),_c('span',{staticClass:"ml-1"},[_vm._v("© "+_vm._s(new Date().getFullYear()))])]),_c('div',{staticClass:"ml-auto"},[_c('span',{staticClass:"mr-1"},[_vm._v("Powered by")]),_c('a',{attrs:{"href":"https://www.mfu.ac.th","target":"_blank"}},[_vm._v("Mae Fah Luang University")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }